import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectPaymentTransferResultReadOnly = () =>
    createSelector(substate, (contextState) => contextState.paymentTransferResultReadOnly);
